export const treeLaraThemeConfig = {
  colorScheme: {
    light: {},
  },
  gap: "0px",
  padding: "0px",
  nodePadding: "0px",
  css: ({ dt }: any) => `
    .p-tree-node-content {
      height: 62px;
    }

  `,
};

/**

 .p-tree-root-children {
 border: 1px solid ${dt('gray.200')}
 }
 .p-tree-root-children > p-treenode:not(:last-child) {
 border-bottom: 1px solid ${dt('gray.200')}
 }
 .p-tree-node-children {
 border-top: 1px solid ${dt('gray.200')};
 padding-inline-start: 0;
 }
 .p-tree-node-children > p-treenode {
 display: block;
 padding-inline-start: ${dt('tree.indent')};
 }
 */
